import React, { ChangeEvent, FocusEvent } from "react"
import styled, { css } from "styled-components"
import { Radio } from "../Radio"

type Props = {
  id: string
  options: {
    name: string
    value: Props["value"]
  }[]
  value: string | number
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: FocusEvent) => void
  required?: boolean
  type?: "width-wide"[]
  className?: string
}

const Component: React.VFC<Props> = (props) => {
  return (
    <div
      className={`${props.className} radios`}
      data-vld-element="radios"
      data-value={props.value}
      id={props.id}
    >
      {props.options.map((option) => (
        <Radio
          key={option.value}
          required={props.required}
          id={`${props.id}_${option.value}`}
          name={props.id}
          checked={option.value === props.value}
          onChange={props.onChange}
          onBlur={props.onBlur}
          value={option.value}
        >
          {option.name}
        </Radio>
      ))}
    </div>
  )
}

const StyledComponent = styled(Component)`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  &::after {
    content: '';
    width: 32%;
  }

  > * {
    width: 32%;
    margin-bottom: 8px;

    ${(props) =>
      props.type?.includes("width-wide") &&
      css`
        width: 100%;
      `}
  }
`

export const Radios = StyledComponent
